// TableHeaders.js
const tableHeadersMapping = {
    '/reports/authentication-performance': [
        { label: 'Authentication ID' },
        { label: 'Product Name' },
        { label: 'Authentication Time' },
        { label: 'Authentication Status' },
        { label: 'Failure Reason' },
        { label: 'Product Ref' },
        { label: 'Timestamp' },
        // { label: 'User ID' }
    ],
    '/reports/anomaly-detection': [
        { label: 'Anomaly ID' },
        { label: 'Anomaly Type' },
        { label: 'Verification ID' },
        { label: 'Product Name' },
        { label: 'Verification Data' },
        { label: 'User ID' }
    ],
    '/reports/geolocation-verification': [
        { label: 'Verification ID' },
        { label: 'Product Name' },
        { label: 'Location Data' },
        { label: 'Verification Timestamp' },
        { label: 'Verification Status' }
    ],
    '/reports/product-specific-verification': [
        { label: 'Product ID' },
        { label: 'Product Name' },
        { label: 'Coordinates' },
        { label: 'Region' },
        { label: 'Country' },
        { label: 'Success Count' },
        { label: 'Invalid Count' },
        { label: 'Suspicious Count' }
    ],
    '/reports/user-activity': [
        { label: 'User Email' },
        { label: 'Module' },
        { label: 'Action Type' },
        { label: 'User Type' },
        { label: 'Timestamp' }
    ],
    '/reports/verification-frequency': [
        { label: 'Product Name' },
        { label: 'Product Code' },
        { label: 'Max Verification Hour' },
        { label: 'Max Verification Count' },
        { label: 'User Type' }
    ],
    // '/reports/audit-trail': [
    //     { label: 'Audit Trail ID' },
    //     { label: 'User ID' },
    //     { label: 'User Type' },
    //     { label: 'Activity Log' },
    //     { label: 'Timestamp' },
    //     { label: 'Verification ID' },
    //     { label: 'Product Name' }
    // ],
    '/reports/alerts-notifications': [
        { label: 'Alert ID' },
        { label: 'Alert Type' },
        { label: 'Verification ID' },
        { label: 'Product Ref' },
        { label: 'Timestamp' },
        { label: 'Remarks' },
        { label: 'Action Taken' },
        { label: 'Notification Method' },
        { label: 'User Email' },
        { label: 'User Type' }
    ]
};

export default tableHeadersMapping;
